import { useParams } from 'react-router-dom';
import { FormBuilder } from '@/components/form-builder/FormBuilder';

const FormBuilderPage = () => {
  const { formId } = useParams<{ formId: string }>();

  return <FormBuilder formId={formId} />;
};

export default FormBuilderPage;